<script setup>

  import FiltroEmail from "./FiltroEmail.vue";
  import FiltroTexto from "./FiltroTexto.vue";
  import FiltroNumero from "./FiltroNumero.vue";
  import FiltroSelector from "./FiltroSelector.vue";

  const props = defineProps({
    filtro: Object,
  })

  // Añadimos el campo para guardar el dato
  props.filtro.value = null;

  // Añadimos ccaa, provincias, poblaciones y países

  switch (props.filtro.tipo) {
    case 'ccaa':
      props.filtro.select_values = JSON.parse(document.getElementById("ccaa").value);
      break;
    
    case 'provincias':
      props.filtro.select_values = JSON.parse(document.getElementById("provincias").value);
      break;
    
    case 'poblaciones':
      props.filtro.select_values = JSON.parse(document.getElementById("poblaciones").value);
      break;
    
    case 'paises':
      props.filtro.select_values = JSON.parse(document.getElementById("paises").value);
      break;
  }

</script>

<template>
  
  <filtro-email v-if="filtro.tipo=='email'" :filtro="filtro"></filtro-email>
  <filtro-texto v-if="filtro.tipo=='texto'" :filtro="filtro"></filtro-texto>
  <filtro-numero v-if="filtro.tipo=='numero'" :filtro="filtro"></filtro-numero>
  <filtro-selector v-if="filtro.tipo=='selector'" :filtro="filtro"></filtro-selector>

  <filtro-selector v-if="filtro.tipo=='ccaa'" :filtro="filtro"></filtro-selector>
  <filtro-selector v-if="filtro.tipo=='provincias'" :filtro="filtro"></filtro-selector>
  <filtro-selector v-if="filtro.tipo=='poblaciones'" :filtro="filtro"></filtro-selector>
  <filtro-selector v-if="filtro.tipo=='paises'" :filtro="filtro"></filtro-selector>
 
</template>

<style lang="scss">

</style>